/**
 * File parallax.js
 *
 * Handles parallax effects
 */

import Rellax from 'rellax';

(() => {
    const parallaxSelector = '.parallax-item';

    if ( $( parallaxSelector ).length ) {
        // Initialize Rellax only if there are matching elements
        const rellax = new Rellax( parallaxSelector, {
            breakpoints: [ 0, 768, 1024 ],
        } );

        const refreshHandler = () => {
            rellax.refresh();
        };

        [ 'load', 'resize', 'modop.rellax-refresh' ].forEach( ( e ) => {
            window.addEventListener( e, refreshHandler );
        } );
    }
})();
